module.exports = __webpack_public_path__ + "static/img/bg_header_hall.a0ece87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ds_img/bg_header_hall.png
// module id = SC6J
// module chunks = 18